import { createAction } from '@reduxjs/toolkit';
export const ACCEPT_CALL = 'ACCEPT_CALL';
export const acceptCallAction = createAction(ACCEPT_CALL);